var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuHumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 6.00005C3.6 5.33731 4.13726 4.80005 4.8 4.80005H19.2C19.8627 4.80005 20.4 5.33731 20.4 6.00005C20.4 6.66279 19.8627 7.20005 19.2 7.20005H4.8C4.13726 7.20005 3.6 6.66279 3.6 6.00005Z",
    fill: "#6B7496"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 12C3.6 11.3373 4.13726 10.8 4.8 10.8H19.2C19.8627 10.8 20.4 11.3373 20.4 12C20.4 12.6628 19.8627 13.2 19.2 13.2H4.8C4.13726 13.2 3.6 12.6628 3.6 12Z",
    fill: "#6B7496"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 18C3.6 17.3373 4.13726 16.8 4.8 16.8H19.2C19.8627 16.8 20.4 17.3373 20.4 18C20.4 18.6628 19.8627 19.2 19.2 19.2H4.8C4.13726 19.2 3.6 18.6628 3.6 18Z",
    fill: "#6B7496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHumb);
export default __webpack_public_path__ + "static/media/menuHumb.5d31b04615ed9a0673da7385417ca3db.svg";
export { ForwardRef as ReactComponent };